<template>
  <div>
    <div class="code-editor-toolbar">
      <CButton color="secondary" size="sm" @click="toggleFullScreen" title="Editar em tela cheia (F11)">
        <fa-icon icon="expand" /> Editar em tela cheia
      </CButton>
    </div>

    <codemirror ref="cmEditor" v-model="modelVal" :options="code_options"></codemirror>

    <!-- Ações flutuantes enquanto em tela cheia (ficam acima do overlay do CodeMirror) -->
    <div v-if="isFullScreen" class="cm-fs-actions">
      <CButton color="secondary" size="sm" @click="toggleFullScreen">
        <fa-icon icon="times" /> Sair da tela cheia
      </CButton>
    </div>
  </div>
</template>

<script>

import ncformCommon from '@ncform/ncform-common';

import { codemirror } from 'vue-codemirror'
import cmFullscreenMixin from '@/components/form/cmFullscreenMixin';

// theme css
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/monokai.css'

// fullscreen
import 'codemirror/addon/display/fullscreen.css'
import 'codemirror/addon/display/fullscreen.js'

// language js
import'codemirror/addon/selection/active-line.js'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/addon/display/autorefresh.js'

// autoCloseTags
import'codemirror/addon/edit/closetag.js'

export default {
  name: "Codeblock",
  mixins: [
      ncformCommon.mixins.vue.controlMixin,
      cmFullscreenMixin,
  ],
  components: {
    codemirror
  },
  data() {
    return {
      code_options: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'text/x-sql',
        autoRefresh: true,
        lineWrapping: true,
        theme: 'monokai',
        showCursorWhenSelecting: true,
        highlightSelectionMatches: {
          showToken: /\w/,
          annotateScrollbar: true
        },
        extraKeys: {
          "F11": () => this.toggleFullScreen(),
        },
      }
    }
  },
  methods: {
    // Tela cheia (setFullScreen/toggleFullScreen/Esc) vem do cmFullscreenMixin.
    getCmEditor() {
      return (this.$refs.cmEditor && this.$refs.cmEditor.codemirror) || null;
    },
  },
}
</script>

<style scoped>
.code-editor-toolbar {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-bottom: 4px;
}

/* Botões flutuantes em tela cheia — canto inferior direito, acima do overlay do CodeMirror (z-index 9) */
.cm-fs-actions {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 20;
  display: flex;
  gap: 8px;
}
</style>
